module.exports = __webpack_public_path__ + "static/img/iv_logo_title.1030542.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/space/iv_logo_title.png
// module id = OL1K
// module chunks = 1